import LOCALS from 'commons/locals';
import { FormLabel } from '../form-label';
import i18n from 'i18n';
import {
  Control,
  Controller,
  FieldErrors,
  UseFormSetValue,
  useWatch,
} from 'react-hook-form';
import { CreateProductFormSchemaType } from '../common';
import { Select } from 'antd';
import { getStockPlaceCurrency } from 'constant/stock-place';
import { STOCK_PLACE_OPTION_LIST } from 'constant/stock-place';
import { getProductTaxRate } from 'utils/stock-place-currency';
import { priceToWithoutTax } from 'utils/price-change';
import ProductTaxRegimeField from './tax-regime';

const ProductStockPlace = ({
  control,
  errors,
  setValue,
}: {
  control: Control<CreateProductFormSchemaType>;
  errors: FieldErrors<CreateProductFormSchemaType>;
  setValue: UseFormSetValue<CreateProductFormSchemaType>;
}) => {
  const price = useWatch({ control, name: 'price' });

  return (
    <div className="flex items-center gap-2">
      <FormLabel required>{i18n.t(LOCALS.stock_place)}:</FormLabel>
      <div className="flex w-full gap-2 items-center">
        <Controller
          name="stockPlace"
          control={control}
          render={({ field }) => (
            <div className="relative w-full">
              <Select
                status={errors.stockPlace ? 'error' : undefined}
                {...field}
                className="w-full"
                options={STOCK_PLACE_OPTION_LIST}
                placeholder={i18n.t(LOCALS.please_select)}
                onChange={(value) => {
                  const currency = getStockPlaceCurrency(value);
                  setValue('currency', currency);
                  field.onChange(value);
                  if (price !== undefined && price !== null) {
                    setValue(
                      'priceWithoutTax',
                      priceToWithoutTax(
                        price,
                        getProductTaxRate(value, currency),
                      ),
                    );
                  }
                }}
              />
              {errors.stockPlace && (
                <p style={{ color: 'red' }} className="absolute left-0">
                  {i18n.t(LOCALS.required_field)}
                </p>
              )}
            </div>
          )}
        />
        <ProductTaxRegimeField
          control={control}
          errors={errors}
          setValue={setValue}
        />
      </div>
    </div>
  );
};

export default ProductStockPlace;
